export enum OpenViduLoggerConfiguration {
    disabled = 'disabled',
    debug = 'debug',
    debug_app = 'debug_app'
}
